const lastPathSegment = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return '';
  return raw.split('/').filter(Boolean).pop() || raw;
};

export const getGcpOperationScope = (operation = {}) => {
  const raw = operation.raw || {};
  const scopeType = operation.scope_type || operation.scopeType;
  if (scopeType === 'global') {
    return { scopeType: 'global', scope: '' };
  }
  if (scopeType === 'zones' || scopeType === 'regions') {
    return { scopeType, scope: lastPathSegment(operation.scope) };
  }
  if (scopeType === 'tpu-locations') {
    return { scopeType, scope: lastPathSegment(operation.scope) };
  }

  const rawName = operation.name || raw.name;
  const rawNameParts = String(rawName || '').split('/').filter(Boolean);
  const locationIndex = rawNameParts.indexOf('locations');
  if (locationIndex >= 0 && rawNameParts[locationIndex + 1]) {
    return { scopeType: 'tpu-locations', scope: rawNameParts[locationIndex + 1] };
  }

  const zone = operation.zone || raw.zone;
  if (zone) {
    return { scopeType: 'zones', scope: lastPathSegment(zone) };
  }

  const region = operation.region || raw.region;
  if (region) {
    return { scopeType: 'regions', scope: lastPathSegment(region) };
  }

  return { scopeType: 'global', scope: '' };
};

export const gcpOperationPaths = {
  list: (connectionId) =>
    `/compute/cloud-account-connections/${connectionId}/gcp/operations`,
  detail: (connectionId, operation) => {
    const operationName = lastPathSegment(operation?.name);
    const { scopeType, scope } = getGcpOperationScope(operation);
    const base = `/compute/cloud-account-connections/${connectionId}/gcp/operations`;

    if (scopeType === 'global') {
      return `${base}/global/${encodeURIComponent(operationName)}`;
    }

    return `${base}/${encodeURIComponent(scopeType)}/${encodeURIComponent(scope)}/${encodeURIComponent(operationName)}`;
  },
};
